<template>
  <v-row>
    <v-col xl="6" lg="6" md="8" sm="12">
      <v-card class="m-2">
        <v-card-text>
  <v-row>
    <v-col sm="4" md="2">
      <v-subheader class="c-label">Name</v-subheader>
    </v-col>
    <v-col>
      <v-text-field
          class="hide-label"
          v-model="kost.name"
          :rules="rules.name"
          counter
          maxlength="50"
          hint="Der Name der Kostenstelle"
          label="Name"
          :disabled="!canEdit && kost.bis_id !== 'Neuanlage'"
          @input="$emit('change', kost.id)"
      ></v-text-field>
    </v-col>
  </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "kost_detail",
  props:{
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          bis_id: '',
          name: '',
          access: '',
        }
      }
    },
    kosts: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      kost: {
        id: '',
        bis_id: '',
        name: '',
        access: '',
      },
      canEdit: false,
      rules: {
        name: [val => (val || '').length > 0 || '*erforderlich'],
      },
    }
  },
  watch: {
    item: {
      handler: function (newVal) {
        this.kost = {...newVal};
      },
      deep: true
    },
  },
  mounted() {
    this.canEdit = this.$cookies.get("ps_username") === 'admin';
    this.kost = {...this.item};
  },
  methods: {
    isValid() {
      return this.kost.name.trim().length > 0;
    },
    resetEdit() {
      this.kost = {...this.item};
    },
    getData() {
      return this.kost;
    }
  }
}
</script>

<style scoped>
  ::v-deep .theme--light.v-input--is-disabled input {
    color: rgba(0, 0, 0, 0.86);
  }

  ::v-deep .hide-label {
    padding-top: 0px !important;
  }

  ::v-deep .hide-label .v-label {
    display: none !important;
  }

  .c-label {
    margin-bottom: 10px;
    color: black;
    font-size: 14px;
    font-weight: 500;
  }
</style>
